import { IShsEquipmentData } from '../models/installedbase.models';
import { Action, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import * as MyInstalledBaseActions from '../actions/my-installed-base.actions';

export interface IMyInstalledBaseState {
  equipments: {
    selectable: IShsEquipmentData[];
    other: IShsEquipmentData[];
    isLoaded: boolean;
  }
  contracts: {
    needsAttention: IShsEquipmentData[];
    underContractContracts: IShsEquipmentData[];
    isLoaded: boolean;
  }
}

export const initialState: IMyInstalledBaseState = {
  equipments: {
    selectable: [],
    other: [],
    isLoaded: false,
  },
  contracts: {
    needsAttention: [],
    underContractContracts: [],
    isLoaded: false,
  }
};

export const reducer = createReducer(
  initialState,

  on(MyInstalledBaseActions.loadMyInstalledBaseEquipments, (state) => {
    return {
      ...state,
      equipments: {
        ...state.equipments,
        isLoaded: false,
      }
    }
  }),

  on(MyInstalledBaseActions.loadMyInstalledBaseEquipmentsSuccess, (state, { selectableEquipments, otherEquipments }) => {
    return {
      ...state,
      equipments: {
        selectable: selectableEquipments,
        other: otherEquipments,
        isLoaded: true,
      }
    }
  }),

  on(MyInstalledBaseActions.loadMyInstalledBaseEquipmentsFailure, (state) => {
    return {
      ...state,
      equipments: {
        ...state.equipments,
        isLoaded: true,
      }
    }
  }),

  on(MyInstalledBaseActions.loadMyInstalledBaseContracts, (state) => {
    return {
      ...state,
      contracts: {
        ...state.contracts,
        isLoaded: false,
      }
    }
  }),

  on(MyInstalledBaseActions.loadMyInstalledBaseContractsSuccess, (state, { needsAttentionContracts, underContractContracts }) => {
    return {
      ...state,
      contracts: {
        needsAttention: needsAttentionContracts,
        underContractContracts: underContractContracts,
        isLoaded: true,
      }
    }
  }),

  on(MyInstalledBaseActions.loadMyInstalledBaseContractsFailure, (state) => {
    return {
      ...state,
      contracts: {
        ...state.contracts,
        isLoaded: true,
      }
    }
  }),
);

export function MyInstalledBaseReducer(state: IMyInstalledBaseState | undefined, action: Action): any {
  return reducer(state, action);
}

export const myInstalledBaseState = createFeatureSelector<IMyInstalledBaseState>('myInstalledBase');

export const selectEquipments = createSelector(
  myInstalledBaseState,
  state => state.equipments
);

export const selectContracts = createSelector(
  myInstalledBaseState,
  state => state.contracts
);

export const selectSelectableEquipments = createSelector(
  myInstalledBaseState,
  state => state.equipments.selectable
);

export const selectOtherEquipments = createSelector(
  myInstalledBaseState,
  state => state.equipments.other
);

export const selectEquipmentsIsLoaded = createSelector(
  myInstalledBaseState,
  state => state.equipments.isLoaded
);

export const selectNeedsAttentionContracts = createSelector(
  myInstalledBaseState,
  state => state.contracts.needsAttention
)

export const selectUnderContractContracts = createSelector(
  myInstalledBaseState,
  state => state.contracts.underContractContracts
)

export const selectContractsIsLoaded = createSelector(
  myInstalledBaseState,
  state => state.contracts.isLoaded
);
